import React from "react";
import RoleGuard from "@/components/RoleGuard";

/**
 * @deprecated Use `<RoleGuard mode="venue">` diretamente.
 */
const ProtectedVenueRoute = React.forwardRef<HTMLDivElement, { children: React.ReactNode }>(
  ({ children }, _ref) => <RoleGuard mode="venue">{children}</RoleGuard>
);

ProtectedVenueRoute.displayName = "ProtectedVenueRoute";

export default ProtectedVenueRoute;
